import { render, staticRenderFns } from "./carousel-list.vue?vue&type=template&id=31bd99fe&"
import script from "./carousel-list.vue?vue&type=script&lang=js&"
export * from "./carousel-list.vue?vue&type=script&lang=js&"
import style0 from "./carousel-list.vue?vue&type=style&index=0&id=31bd99fe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports